module.exports = __webpack_public_path__ + "static/Ruslan-blur-over-7fde233be055212f955bb2a1a2b6005b.jpg";